import React from 'react';
import './Cart.css';
import { Link} from "react-router-dom";



class Cart extends React.Component {

  constructor(props) {
    super(props);
    this.savetolocal = this.savetolocal.bind(this);
  }

  savetolocal (e) {
    localStorage.setItem('count',this.props.count)
    localStorage.setItem('cartProducts',JSON.stringify(this.props.cartProducts))
  }
    render () {
      return (
        <div className={this.props.count > 0 ? "showCart hideCart" : "hideCart"}>
          <Link to="/keranjang" onClick={this.savetolocal}>
            <div className="cart shadow">
              <span>
                <i className="fa fa-shopping-cart" aria-hidden="true"></i>&nbsp;Keranjang({this.props.count})
              </span>
            </div>
          </Link>
        </div>
      );
    }
  }


export default Cart;
